import { z } from 'zod/v4';

import { partEngineeringOperationSchema } from '../part-engineering-operation';
import { partEngineeringRequirementSchema } from '../part-engineering-requirement';
import { columns } from './columns';

export const partEngineeringSchema = z.object(columns);

export const partEngineeringWithOpsAndReqsSchema = z.object(columns).extend({
  operations: z.array(
    partEngineeringOperationSchema.extend({
      requirements: z.array(partEngineeringRequirementSchema),
    }),
  ),
});

// limit the fields only to what's needed for upsert on WO sync
export const partEngineeringWithOpsAndReqsUpsertSchema = z
  .object(columns)
  .omit({
    // not used in the prisma query
    id: true,
    createdById: true,
    createdByService: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    operations: z.array(
      partEngineeringOperationSchema
        .omit({
          // not used in the prisma query
          id: true,

          createdById: true,
          createdByService: true,
          createdAt: true,
          updatedAt: true,

          // was not in previous transform
          quotingConfigId: true,
          // custom old-SNAP stuff that we don't care about
          qtyPerLineQty: true,
          runHrsPerLineQty: true,
          qtyPerRunHr: true,

          /** These fields were computed from the LABOR_TICKET table
           * see: packages/lib/src/kysely/visual/queries/operation.ts
           *
           * We are not using them with the new calculations, so
           * ignore them for the time being.
           */
          actLabSetupCostPerHr: true,
          actLabRunCostPerHr: true,
          actBurSetupCostPerHr: true,
          actBurRunCostPerHr: true,
        })
        .extend({
          requirements: z.array(
            partEngineeringRequirementSchema.omit({
              // not used in the prisma query
              id: true,
              createdById: true,
              createdByService: true,
              createdAt: true,
              updatedAt: true,

              estUnitsPerOpQty: true,
              estUnitsPerLineQty: true,
              minMtrlCost: true,

              quotingConfigId: true,
            }),
          ),
        }),
    ),
  });

export type PartEngineeringWithOpsAndReqs = z.output<
  typeof partEngineeringWithOpsAndReqsSchema
>;

export type PartEngineeringWithOpsAndReqsUpsert = z.output<
  typeof partEngineeringWithOpsAndReqsUpsertSchema
>;
